module.exports = __webpack_public_path__ + "img/nlic_gallery6.057af2ee.jpg";